import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "notification is-warning" }, " No exports to display. ", -1)
const _hoisted_2 = { class: "table is-hoverable is-fullwidth" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("th", null, "Creator", -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("th", null, "State", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("th", null, "Updated", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("th", { class: "is-narrow" }, "Actions", -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["title"]
const _hoisted_10 = { class: "is-narrow" }
const _hoisted_11 = { class: "field is-grouped" }
const _hoisted_12 = ["href"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "icon-download" }, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = ["disabled", "onClick"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "icon-trash" }, null, -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "columns is-marginless" }
const _hoisted_20 = { class: "column is-paddingless" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { class: "column is-paddingless is-narrow" }
const _hoisted_23 = { class: "field has-addons" }
const _hoisted_24 = {
  key: 0,
  class: "control"
}
const _hoisted_25 = { class: "select is-truncated" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = ["value"]
const _hoisted_28 = { class: "control" }
const _hoisted_29 = ["title", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_DeleteModal = _resolveComponent("DeleteModal")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    "model-value": _ctx.modelValue,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = value => _ctx.$emit('update:modelValue', value)),
    title: _ctx.title
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["button mr-2", { 'is-loading': _ctx.loading }]),
            disabled: _ctx.loading || undefined,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.load(_ctx.page)))
          }, " Refresh ", 10, _hoisted_21)
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            (_ctx.hasFeature('enterprise') && _ctx.isVerified && _ctx.sources?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _withDirectives(_createElementVNode("select", {
                      disabled: _ctx.loading || _ctx.sources === null || undefined,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.source) = $event))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sources, ({ name, last_update }) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: name,
                          value: name
                        }, [
                          _createTextVNode(_toDisplayString(name) + " ", 1),
                          (last_update !== null)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(" (last updated " + _toDisplayString(_ctx.dateAgo(last_update)) + ") ", 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_27))
                      }), 128))
                    ], 8, _hoisted_26), [
                      [_vModelSelect, _ctx.source]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["button is-primary", { 'is-loading': _ctx.loading }]),
                title: _ctx.buttonTitle,
                disabled: !_ctx.canStart || _ctx.loading || undefined,
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.startExport && _ctx.startExport(...args)))
              }, " Start export ", 10, _hoisted_29)
            ])
          ])
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_Paginator, {
        response: _ctx.corpusExports[_ctx.corpusId],
        loading: _ctx.loading,
        singular: "export",
        plural: "exports",
        page: _ctx.page,
        "onUpdate:page": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.page) = $event))
      }, {
        "no-results": _withCtx(() => [
          _hoisted_1
        ]),
        default: _withCtx(({ results }) => [
          _createElementVNode("table", _hoisted_2, [
            _createElementVNode("tr", null, [
              _hoisted_3,
              (_ctx.hasFeature('enterprise'))
                ? (_openBlock(), _createElementBlock("th", _hoisted_4, "Source"))
                : _createCommentVNode("", true),
              _hoisted_5,
              _hoisted_6,
              _hoisted_7
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((results as CorpusExport[]), (corpusExport) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: corpusExport.id
              }, [
                _createElementVNode("td", null, _toDisplayString(corpusExport.user.display_name), 1),
                (_ctx.hasFeature('enterprise'))
                  ? (_openBlock(), _createElementBlock("td", _hoisted_8, _toDisplayString(corpusExport.source), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("td", null, _toDisplayString(_ctx.EXPORT_STATES[corpusExport.state]), 1),
                _createElementVNode("td", {
                  title: corpusExport.updated
                }, _toDisplayString(_ctx.dateAgo(corpusExport.updated)), 9, _hoisted_9),
                _createElementVNode("td", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("a", {
                      href: _ctx.downloadLink(corpusExport),
                      target: "_blank"
                    }, [
                      _createElementVNode("button", {
                        class: "button is-small is-primary",
                        disabled: !_ctx.downloadLink(corpusExport)
                      }, _hoisted_15, 8, _hoisted_13)
                    ], 8, _hoisted_12),
                    _createElementVNode("button", {
                      class: "button is-small is-danger",
                      disabled: !_ctx.canDelete(corpusExport),
                      onClick: ($event: any) => (_ctx.openDeleteModal(corpusExport))
                    }, _hoisted_18, 8, _hoisted_16)
                  ])
                ])
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["response", "loading", "page"]),
      (_ctx.toDelete && _ctx.canDelete(_ctx.toDelete))
        ? (_openBlock(), _createBlock(_component_DeleteModal, {
            key: 0,
            modelValue: _ctx.deleteModal,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.deleteModal) = $event)),
            "corpus-export": _ctx.toDelete
          }, null, 8, ["modelValue", "corpus-export"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["model-value", "title"]))
}